var AF_ZAPIER_WEBHOOK = 'https://hooks.zapier.com/hooks/catch/6805973/uv4myls/';
var AF_SCROLL_ID = 'shopify-section-template--25564379086959__rich_text_aUcD6i';
var AF_TOTAL_STEPS = { p: 5, b: 6 };
var afCurrentStep = { p: 1, b: 1 };
var afWidgets = {};

function afScroll() {
  var el = document.getElementById(AF_SCROLL_ID);
  if (el) { el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  else { window.scrollTo({ top: 0, behavior: 'smooth' }); }
}

function afUpdateProgress(prefix, step) {
  var total = AF_TOTAL_STEPS[prefix];
  var container = document.getElementById('af-' + prefix + '-progress');
  if (!container) return;
  container.querySelectorAll('.step-node').forEach(function(node, i) {
    var n = i + 1;
    node.classList.remove('active', 'done');
    var circle = node.querySelector('.step-circle');
    if (n < step) { node.classList.add('done'); circle.innerHTML = '&#10003;'; }
    else if (n === step) { node.classList.add('active'); circle.innerHTML = '<span class="step-num">' + n + '</span>'; }
    else { circle.innerHTML = '<span class="step-num">' + n + '</span>'; }
  });
  var fill = document.getElementById('af-' + prefix + '-fill');
  if (fill) fill.style.width = (((step - 1) / (total - 1)) * 100) + '%';
}

function afShowStep(prefix, step) {
  var form = document.getElementById(prefix === 'p' ? 'af-personal' : 'af-business');
  if (!form) return;
  form.querySelectorAll('.af-step-panel').forEach(function(p) { p.classList.remove('active'); });
  var panel = document.getElementById('af-' + prefix + '-step' + step);
  if (panel) panel.classList.add('active');
  afUpdateProgress(prefix, step);
  afCurrentStep[prefix] = step;
  afScroll();
}

function afSelectType(type) {
  document.getElementById('af-personal').classList.remove('active');
  document.getElementById('af-business').classList.remove('active');
  if (type === 'personal') {
    document.getElementById('af-personal').classList.add('active');
    afShowStep('p', afCurrentStep.p);
  } else if (type === 'business') {
    document.getElementById('af-business').classList.add('active');
    afShowStep('b', afCurrentStep.b);
  }
}

function afToggle(wrapperId, show) {
  var el = document.getElementById(wrapperId);
  if (el) el.classList.toggle('visible', show);
}

function afGv(id) {
  var el = document.getElementById(id);
  return el ? el.value : '';
}

// Get file info from an Uploadcare widget as a promise resolving to array of {name, url}
function afGetWidgetFiles(widgetId) {
  return new Promise(function(resolve) {
    var widget = afWidgets[widgetId];
    if (!widget || !widget.value()) { resolve([]); return; }
    var val = widget.value();
    // Multiple file group
    if (typeof val.files === 'function') {
      var filePromises = val.files().map(function(filePromise) {
        return new Promise(function(res) {
          filePromise.done(function(info) {
            res({ name: info.name, url: info.cdnUrl });
          }).fail(function() { res(null); });
        });
      });
      Promise.all(filePromises).then(function(results) {
        resolve(results.filter(Boolean));
      });
    } else {
      // Single file
      val.done(function(info) {
        resolve([{ name: info.name, url: info.cdnUrl }]);
      }).fail(function() { resolve([]); });
    }
  });
}

function afWidgetHasFiles(widgetId) {
  var widget = afWidgets[widgetId];
  return widget && widget.value() !== null;
}

function afValidateFields(prefix, fields) {
  var ok = true;
  fields.forEach(function(f) {
    var el = document.getElementById(prefix + '-' + f.id);
    var err = document.getElementById(prefix + '-err-' + f.id);
    if (!el) return;
    if (!f.check(el.value)) {
      el.classList.add('invalid');
      if (err) err.classList.add('visible');
      ok = false;
    } else {
      el.classList.remove('invalid');
      if (err) err.classList.remove('visible');
    }
  });
  return ok;
}

function afValidateUploads(prefix, keys) {
  var ok = true;
  keys.forEach(function(key) {
    var err = document.getElementById(prefix + '-err-' + key);
    if (!afWidgetHasFiles(prefix + '-' + key)) {
      if (err) err.classList.add('visible');
      ok = false;
    } else {
      if (err) err.classList.remove('visible');
    }
  });
  return ok;
}

function afRunValidator(prefix, step) {
  var notEmpty = function(v) { return v.trim().length > 0; };
  var isEmail  = function(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.trim()); };
  var notBlank = function(v) { return v !== ''; };

  if (prefix === 'p') {
    if (step === 1) return afValidateFields('p', [
      { id: 'firstName', check: notEmpty }, { id: 'lastName', check: notEmpty },
      { id: 'email', check: isEmail }, { id: 'phone', check: notEmpty }
    ]);
    if (step === 2) return afValidateFields('p', [
      { id: 'address1', check: notEmpty }, { id: 'city', check: notEmpty },
      { id: 'province', check: notEmpty }, { id: 'zipCode', check: notEmpty },
      { id: 'ownershipStatus', check: notBlank }, { id: 'addressDuration', check: notEmpty }
    ]);
    if (step === 3) return afValidateUploads('p', ['proofOfResidence','bankStatement','personalId','payslip']);
    if (step === 4) {
      var ok = afValidateFields('p', [
        { id: 'maritalStatus', check: notBlank }, { id: 'hasDependents', check: notBlank },
        { id: 'requiresNewNumber', check: notBlank }, { id: 'keepingNumber', check: notBlank },
        { id: 'networkProvider', check: notEmpty }, { id: 'isPrepaid', check: notBlank }
      ]);
      if (afGv('p-hasDependents') === 'Yes') {
        var dv = afGv('p-dependentsCount');
        var de = document.getElementById('p-err-dependentsCount');
        var del = document.getElementById('p-dependentsCount');
        if (!dv || parseInt(dv) < 1) { del.classList.add('invalid'); de.classList.add('visible'); ok = false; }
        else { del.classList.remove('invalid'); de.classList.remove('visible'); }
      }
      if (afGv('p-keepingNumber') === 'Yes') {
        var nv = afGv('p-numberToKeep');
        var ne = document.getElementById('p-err-numberToKeep');
        var nel = document.getElementById('p-numberToKeep');
        if (!nv.trim()) { nel.classList.add('invalid'); ne.classList.add('visible'); ok = false; }
        else { nel.classList.remove('invalid'); ne.classList.remove('visible'); }
      }
      return ok;
    }
  }

  if (prefix === 'b') {
    if (step === 1) return afValidateFields('b', [
      { id: 'firstName', check: notEmpty }, { id: 'lastName', check: notEmpty },
      { id: 'email', check: isEmail }, { id: 'phone', check: notEmpty }
    ]);
    if (step === 2) return afValidateFields('b', [
      { id: 'companyName', check: notEmpty }, { id: 'businessEmail', check: isEmail },
      { id: 'businessPhone', check: notEmpty }, { id: 'natureOfTrade', check: notEmpty },
      { id: 'tradingDuration', check: notEmpty },
      { id: 'employees', check: function(v) { return v.trim().length > 0 && parseInt(v) >= 1; } }
    ]);
    if (step === 3) return afValidateFields('b', [
      { id: 'address1', check: notEmpty }, { id: 'city', check: notEmpty },
      { id: 'province', check: notEmpty }, { id: 'zipCode', check: notEmpty },
      { id: 'ownershipStatus', check: notBlank }, { id: 'addressDuration', check: notEmpty }
    ]);
    if (step === 4) return afValidateUploads('b', ['proofOfResidence','bankStatement','directorId','ckRegistration','letterhead']);
    if (step === 5) {
      var ok = afValidateFields('b', [
        { id: 'requiresNewNumber', check: notBlank }, { id: 'keepingNumber', check: notBlank },
        { id: 'networkProvider', check: notEmpty }, { id: 'isPrepaid', check: notBlank }
      ]);
      if (afGv('b-keepingNumber') === 'Yes') {
        var nv = afGv('b-numberToKeep');
        var ne = document.getElementById('b-err-numberToKeep');
        var nel = document.getElementById('b-numberToKeep');
        if (!nv.trim()) { nel.classList.add('invalid'); ne.classList.add('visible'); ok = false; }
        else { nel.classList.remove('invalid'); ne.classList.remove('visible'); }
      }
      return ok;
    }
  }
  return true;
}

function afNext(prefix, step) {
  if (!afRunValidator(prefix, step)) return;
  var lastStep = AF_TOTAL_STEPS[prefix] - 1;
  if (step === lastStep) afBuildReview(prefix);
  afShowStep(prefix, step + 1);
}

function afPrev(prefix, step) {
  afShowStep(prefix, step - 1);
}

function afBuildReview(prefix) {
  var wrap = document.getElementById('af-' + prefix + '-review');
  if (!wrap) return;

  function fileLabel(widgetId) {
    var widget = afWidgets[widgetId];
    if (!widget || !widget.value()) return '<span style="color:#aaa">No files uploaded</span>';
    // Try to get file count from group
    var val = widget.value();
    if (typeof val.files === 'function') {
      var count = val.files().length;
      var groupUrl = val.cdnUrl || '';
      return count + ' file' + (count !== 1 ? 's' : '') + ' uploaded' +
        (groupUrl ? ' &mdash; <a href="' + groupUrl + '" target="_blank" style="color:#E8922A">View</a>' : '');
    }
    return 'File uploaded';
  }

  var sections = [];

  if (prefix === 'p') {
    var hasDep  = afGv('p-hasDependents') === 'Yes';
    var keepNum = afGv('p-keepingNumber') === 'Yes';
    sections = [
      { title: 'Personal Details', items: [
        { label: 'First Name', value: afGv('p-firstName') }, { label: 'Last Name', value: afGv('p-lastName') },
        { label: 'Email', value: afGv('p-email') }, { label: 'Phone', value: afGv('p-phone') }
      ]},
      { title: 'Address', items: [
        { label: 'Address Line 1', value: afGv('p-address1') }, { label: 'Address Line 2', value: afGv('p-address2') || '&mdash;' },
        { label: 'City / Town', value: afGv('p-city') }, { label: 'Province', value: afGv('p-province') },
        { label: 'Zip Code', value: afGv('p-zipCode') }, { label: 'Ownership', value: afGv('p-ownershipStatus') },
        { label: 'Time at address', value: afGv('p-addressDuration') }
      ]},
      { title: 'Documents', fileLinks: [
        { label: 'Proof of Residence', widgetId: 'p-proofOfResidence' },
        { label: 'Bank Statement', widgetId: 'p-bankStatement' },
        { label: 'Personal ID', widgetId: 'p-personalId' },
        { label: 'Payslip', widgetId: 'p-payslip' }
      ]},
      { title: 'Account Details', items: (function() {
        var items = [
          { label: 'Marital Status', value: afGv('p-maritalStatus') },
          { label: 'Has Dependants', value: afGv('p-hasDependents') }
        ];
        if (hasDep) items.push({ label: 'Number of Dependants', value: afGv('p-dependentsCount') });
        items.push({ label: 'Requires New Number', value: afGv('p-requiresNewNumber') });
        items.push({ label: 'Keeping a Number', value: afGv('p-keepingNumber') });
        if (keepNum) items.push({ label: 'Number to Keep', value: afGv('p-numberToKeep') });
        items.push({ label: 'Network Provider', value: afGv('p-networkProvider') });
        items.push({ label: 'Is Prepaid', value: afGv('p-isPrepaid') });
        return items;
      })()}
    ];
  } else {
    var keepNumB = afGv('b-keepingNumber') === 'Yes';
    sections = [
      { title: 'Personal Details', items: [
        { label: 'First Name', value: afGv('b-firstName') }, { label: 'Last Name', value: afGv('b-lastName') },
        { label: 'Email', value: afGv('b-email') }, { label: 'Phone', value: afGv('b-phone') }
      ]},
      { title: 'Business Details', items: [
        { label: 'Company Name', value: afGv('b-companyName') }, { label: 'Business Email', value: afGv('b-businessEmail') },
        { label: 'Business Phone', value: afGv('b-businessPhone') }, { label: 'Alt Phone', value: afGv('b-businessPhoneAlt') || '&mdash;' },
        { label: 'Nature of Trade', value: afGv('b-natureOfTrade') }, { label: 'Trading Duration', value: afGv('b-tradingDuration') },
        { label: 'Employees', value: afGv('b-employees') }
      ]},
      { title: 'Address', items: [
        { label: 'Address Line 1', value: afGv('b-address1') }, { label: 'Address Line 2', value: afGv('b-address2') || '&mdash;' },
        { label: 'City / Town', value: afGv('b-city') }, { label: 'Province', value: afGv('b-province') },
        { label: 'Zip Code', value: afGv('b-zipCode') }, { label: 'Ownership', value: afGv('b-ownershipStatus') },
        { label: 'Time at address', value: afGv('b-addressDuration') }
      ]},
      { title: 'Documents', fileLinks: [
        { label: 'Proof of Residence', widgetId: 'b-proofOfResidence' },
        { label: 'Bank / Financial Statement', widgetId: 'b-bankStatement' },
        { label: "Director's ID", widgetId: 'b-directorId' },
        { label: 'CK Registration', widgetId: 'b-ckRegistration' },
        { label: 'Company Letterhead', widgetId: 'b-letterhead' }
      ]},
      { title: 'Account Details', items: (function() {
        var items = [
          { label: 'Requires New Number', value: afGv('b-requiresNewNumber') },
          { label: 'Keeping a Number', value: afGv('b-keepingNumber') }
        ];
        if (keepNumB) items.push({ label: 'Number to Keep', value: afGv('b-numberToKeep') });
        items.push({ label: 'Network Provider', value: afGv('b-networkProvider') });
        items.push({ label: 'Is Prepaid', value: afGv('b-isPrepaid') });
        return items;
      })()}
    ];
  }

  wrap.innerHTML = sections.map(function(s) {
    if (s.fileLinks) {
      var filesHTML = s.fileLinks.map(function(f) {
        return '<div style="grid-column:span 2"><div class="af-review-label">' + f.label + '</div><div class="af-review-files">' + fileLabel(f.widgetId) + '</div></div>';
      }).join('');
      return '<div class="af-review-section"><div class="af-review-section-title">' + s.title + '</div><div class="af-review-grid">' + filesHTML + '</div></div>';
    }
    var itemsHTML = s.items.map(function(item) {
      return '<div><div class="af-review-label">' + item.label + '</div><div class="af-review-value">' + (item.value || '&mdash;') + '</div></div>';
    }).join('');
    return '<div class="af-review-section"><div class="af-review-section-title">' + s.title + '</div><div class="af-review-grid">' + itemsHTML + '</div></div>';
  }).join('');
}

async function afSubmit(prefix) {
  var btn = document.getElementById(prefix + '-submitBtn');
  var status = document.getElementById(prefix + '-formStatus');
  var agree = document.getElementById(prefix + '-agreeTerms');
  var agreeErr = document.getElementById(prefix + '-err-agreeTerms');

  status.className = 'af-status'; status.textContent = '';
  if (!agree.checked) { agreeErr.classList.add('visible'); return; }
  agreeErr.classList.remove('visible');
  btn.disabled = true; btn.textContent = 'Submitting...';

  // Collect file URLs by waiting for each widget's promise to resolve
  var fileKeys = prefix === 'p'
    ? ['proofOfResidence', 'bankStatement', 'personalId', 'payslip']
    : ['proofOfResidence', 'bankStatement', 'directorId', 'ckRegistration', 'letterhead'];

  var filesPayload = {};
  try {
    for (var i = 0; i < fileKeys.length; i++) {
      var key = fileKeys[i];
      var files = await afGetWidgetFiles(prefix + '-' + key);
      filesPayload[key] = files.map(function(f) { return f.url; });
    }
  } catch(e) {
    console.log('File collection error:', e);
    status.className = 'af-status error';
    status.textContent = 'Error reading uploaded files. Please try again.';
    btn.disabled = false; btn.textContent = 'Submit Application'; return;
  }

  var payload = { formType: prefix === 'p' ? 'personal' : 'business', files: filesPayload };

  if (prefix === 'p') {
    Object.assign(payload, {
      firstName: afGv('p-firstName'), lastName: afGv('p-lastName'),
      email: afGv('p-email'), phone: afGv('p-phone'),
      address1: afGv('p-address1'), address2: afGv('p-address2'),
      city: afGv('p-city'), province: afGv('p-province'),
      zipCode: afGv('p-zipCode'), ownershipStatus: afGv('p-ownershipStatus'),
      addressDuration: afGv('p-addressDuration'),
      maritalStatus: afGv('p-maritalStatus'), hasDependents: afGv('p-hasDependents'),
      dependentsCount: afGv('p-dependentsCount') || null,
      requiresNewNumber: afGv('p-requiresNewNumber'),
      keepingNumber: afGv('p-keepingNumber'), numberToKeep: afGv('p-numberToKeep') || null,
      networkProvider: afGv('p-networkProvider'), isPrepaid: afGv('p-isPrepaid')
    });
  } else {
    Object.assign(payload, {
      firstName: afGv('b-firstName'), lastName: afGv('b-lastName'),
      email: afGv('b-email'), phone: afGv('b-phone'),
      companyName: afGv('b-companyName'), businessEmail: afGv('b-businessEmail'),
      businessPhone: afGv('b-businessPhone'), businessPhoneAlt: afGv('b-businessPhoneAlt') || null,
      natureOfTrade: afGv('b-natureOfTrade'), tradingDuration: afGv('b-tradingDuration'),
      employees: afGv('b-employees'),
      address1: afGv('b-address1'), address2: afGv('b-address2'),
      city: afGv('b-city'), province: afGv('b-province'),
      zipCode: afGv('b-zipCode'), ownershipStatus: afGv('b-ownershipStatus'),
      addressDuration: afGv('b-addressDuration'),
      requiresNewNumber: afGv('b-requiresNewNumber'),
      keepingNumber: afGv('b-keepingNumber'), numberToKeep: afGv('b-numberToKeep') || null,
      networkProvider: afGv('b-networkProvider'), isPrepaid: afGv('b-isPrepaid')
    });
  }

  try {
    var resp = await fetch(AF_ZAPIER_WEBHOOK, { method: 'POST', body: JSON.stringify(payload) });
    if (resp.ok) {
      // Show success message
      status.className = 'af-status success';
      status.textContent = 'Upload successful. Your application has been submitted and we will be in touch shortly.';
      // Reset form after delay so user can read the message
      setTimeout(function() {
        document.getElementById('af-' + prefix + '-form').reset();
        var wrapper = document.getElementById(prefix === 'p' ? 'af-personal' : 'af-business');
        // Reset Uploadcare widgets
        wrapper.querySelectorAll('[role="uploadcare-uploader"]').forEach(function(el) {
          var w = afWidgets[el.id];
          if (w) w.value(null);
        });
        wrapper.querySelectorAll('.af-conditional').forEach(function(el) { el.classList.remove('visible'); });
        status.className = 'af-status';
        status.textContent = '';
        afShowStep(prefix, 1);
      }, 4000);
    } else { throw new Error('Status ' + resp.status); }
  } catch(e) {
    console.log('Submit error:', e);
    status.className = 'af-status error';
    status.textContent = 'Something went wrong. Please try again or contact us directly.';
  }
  btn.disabled = false; btn.textContent = 'Submit Application';
}

function afBindClearErrors(prefix) {
  var form = document.getElementById(prefix === 'p' ? 'af-personal' : 'af-business');
  if (!form) return;
  form.querySelectorAll('input, select').forEach(function(el) {
    ['input','change'].forEach(function(evt) {
      el.addEventListener(evt, function() {
        el.classList.remove('invalid');
        var errId = el.id.replace(prefix + '-', prefix + '-err-');
        var err = document.getElementById(errId);
        if (err) err.classList.remove('visible');
      });
    });
  });
}

function afInitUploadcare() {
  if (typeof uploadcare === 'undefined') {
    setTimeout(afInitUploadcare, 200);
    return;
  }
  var uploaderIds = [
    'p-proofOfResidence', 'p-bankStatement', 'p-personalId', 'p-payslip',
    'b-proofOfResidence', 'b-bankStatement', 'b-directorId', 'b-ckRegistration', 'b-letterhead'
  ];
  uploaderIds.forEach(function(id) {
    var el = document.getElementById(id);
    if (el) {
      afWidgets[id] = uploadcare.Widget(el);
    }
  });
}

function afInit() {
  afBindClearErrors('p');
  afBindClearErrors('b');
  afUpdateProgress('p', 1);
  afUpdateProgress('b', 1);
  afInitUploadcare();
}

if (document.readyState === 'complete') {
  afInit();
} else {
  window.addEventListener('load', afInit);
}
